export const STEP_INIT = 0;
export const STEP_FIRST_ANALYSIS = 1;
export const STEP_SECOND_ANALYSIS = 2;
export const STEP_NOT_OK = 3;
export const STEP_OK = 4;

export const ITEMS_NAMES = [
  'Dosimetre operationnel',
  'Dosimetre passif',
  'Casque',
  'Gants',
  'Chaussures',
  'Badge'
]

export const ITEMS_IMAGE_TOP_POSITIONS = [
  36.3,
  29.8,
  4.4,
  50.7,
  88,
  23.4
];

export const STEPS_DATA = [
  { id: '1', name: 'Présence des équipements', status: 'upcoming' },
  { id: '2', name: 'Vérification activation dosimètre', status: 'upcoming' },
];

export const CAMERA_STATE_OK = 0;
export const CAMERA_STATE_BLACK = 1;
export const CAMERA_STATE_LOW_LUMINOSITY = 2;
export const CAMERA_STATE_MOVING = 3;
export const CAMERA_STATE_OBSTRUCTED = 4;
